export enum OwnerDocument {
  RG = 'RG',
  CPF = 'CPF',
  CNH = 'CNH',
  BIRTH_CERTIFICATE = 'CERTIDAO_DE_NASCIMENTO',
  MARRIAGE_CERTIFICATE = 'CERTIDAO_DE_CASAMENTO',
  DIVORCE_CERTIFICATE = 'CERTIDAO_DE_DIVORCIO',
  DEATH_CERTIFICATE = 'CERTIDAO_DE_OBITO',
}
